import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FunctionalButton from "components/layout/FunctionalButton";
import RecordingsGallery from "components/control/RecordingsGallery";
import { ReactComponent as ArrowLeftIcon } from "assets/svgs/ArrowLeft.svg";
import { getRecorderBaseUrl } from "lib/recorderApi";
import { useARC } from "providers/ARC/ARCProvider";
import useIsHttpSecure from "lib/utils/useIsHttpSecure";
import useFleetArcId from "lib/utils/useFleetArcId";

const GalleryPage: React.FC = () => {
    const { t } = useTranslation("control");
    const navigate = useNavigate();
    const { selectedARC } = useARC();
    const isSecure = useIsHttpSecure();
    const arcId = useFleetArcId();
    const baseUrl = useMemo(
        () => getRecorderBaseUrl(selectedARC?.host, isSecure, arcId),
        [selectedARC?.host, isSecure, arcId]
    );

    return (
        <div className="flex h-full min-h-0 w-full flex-col bg-black90">
            <div className="flex shrink-0 items-center justify-between border-b border-black80 px-4 py-3">
                <h2 className="text-h3 font-semibold text-white">
                    {t("bottomBar.gallery")}
                </h2>
                <FunctionalButton
                    icon={<ArrowLeftIcon className="h-4 w-4 fill-white" />}
                    className="h-9 w-9 shrink-0 rounded-r5 border border-primary2 bg-primary2 hover:bg-primary1"
                    onClick={() => navigate("..")}
                />
            </div>
            <RecordingsGallery baseUrl={baseUrl} className="min-h-0 flex-1" />
        </div>
    );
};

export default GalleryPage;
